document.addEventListener('DOMContentLoaded', function () {
  document.getElementById('register-submit').addEventListener('click', function (event) {
    const password = document.getElementById('CreatePassword').value;
    const confirmPassword = document.getElementById('ConfirmPassword').value;

    if (password !== confirmPassword) {
      event.preventDefault();
      alert('Passwords do not match. Please confirm your password.');
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function() {
    document.querySelectorAll('div[data-section-type="recently-viewed"] .grid__item')
      .forEach(function (item) {
        let titleElement = item.querySelector(".grid-product__title");
        if (titleElement) {
          let titleText = titleElement.textContent.trim();
          if (titleText.startsWith("Room")) {
            item.style.display = "none";
          }
        }
      });
  }, 2000);
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".megamenu image-element").forEach(function (img) {
    if (!img.classList.contains("aos-animate")) {
      img.classList.add("aos-animate");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
      const wishlistButton = document.querySelector("#SiteHeader .st-wishlist-details-button");
  
      if (wishlistButton) {
          const existingSvg = wishlistButton.querySelector("svg");
          if (existingSvg) {
              existingSvg.remove();
          }
  
          wishlistButton.insertAdjacentHTML("afterbegin", `
              <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.8208 4.9529L12 5.13708L12.1792 4.9529L13.1647 3.93991C15.349 1.69483 19.3902 2.4568 20.852 5.3116C21.5299 6.63558 21.7038 8.58072 20.4199 11.1136C19.1924 13.5352 16.6371 16.4599 12 19.664C7.36289 16.4599 4.80762 13.5352 3.58014 11.1136C2.29624 8.58072 2.47007 6.63558 3.14802 5.3116C4.60982 2.4568 8.65104 1.69483 10.8353 3.93991L11.8208 4.9529ZM11.8622 21.8336L12 21.9246L12.1378 21.8336C17.4288 18.3375 20.5072 15.0169 22.033 12.077C23.5617 9.13131 23.5328 6.56224 22.5962 4.60883C20.7371 0.731502 15.3331 -0.61368 12.0722 2.38781C12.048 2.41009 12.024 2.4326 12 2.45536C11.976 2.4326 11.952 2.41008 11.9277 2.3878C8.66686 -0.613678 3.2629 0.731509 1.40384 4.60883C0.46724 6.56225 0.438256 9.13132 1.96702 12.077C3.49283 15.0169 6.57116 18.3375 11.8622 21.8336Z" fill="black" stroke="black" stroke-width="0.5"/>
              </svg>
          `);
      }
    }, 2000);
});

document.addEventListener("DOMContentLoaded", function () {
  const imageContainers = document.querySelectorAll(".template-product .product-section .product-image-main image-element");

  imageContainers.forEach((container) => {
    const image = container.querySelector("img");
    const zoomButton = container.nextElementSibling;

    if (image && zoomButton) {
      container.style.overflow = "hidden";

      container.addEventListener("mousemove", function (e) {
        const { left, top, width, height } = container.getBoundingClientRect();
        const x = ((e.pageX - left) / width) * 100;
        const y = ((e.pageY - top) / height) * 100;

        image.style.transformOrigin = `${x}% ${y}%`;
        image.style.transform = "scale(2)";
      });

      container.addEventListener("mouseleave", function () {
        image.style.transform = "scale(1)";
      });

      container.addEventListener("click", function () {
        zoomButton.click();
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-card-form").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: data }));
      })
      .catch(error => console.error("Error adding product:", error));
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const toolbar = document.querySelector('.toolbar.small--hide');

  if (!toolbar) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 0) {
      toolbar.classList.add('toolbar--stuck');
    } else {
      toolbar.classList.remove('toolbar--stuck');
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  function refreshCartCounter() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const counter = document.querySelector('.cart-quantity');
        if (counter) counter.textContent = cart.item_count;
      });
  }

  // Adjust the selector if your "Add to Cart" buttons have a different class
  document.querySelectorAll('.add-to-cart-button').forEach(button => {
    button.addEventListener('click', () => {
      setTimeout(refreshCartCounter, 500); // delay to allow cart update
    });
  });
});

function equalizeHeights() {
  const items = document.querySelectorAll(".template-blog .page-content > .grid > .grid__item");
  let maxHeight = 0;

  items.forEach(item => {
    item.style.height = "auto";
    const height = item.offsetHeight;
    if (height > maxHeight) maxHeight = height;
  });

  items.forEach(item => {
    item.style.height = maxHeight + "px";
  });
}

document.addEventListener("DOMContentLoaded", equalizeHeights);
window.addEventListener("resize", equalizeHeights);



document.addEventListener('DOMContentLoaded', function() {
    // Function to move each .nm-portal out of its current .add-to-cart-cont
    function moveNmPortal() {
        // Select all nm-portal elements
        const nmPortals = document.querySelectorAll('.nm-portal');

        nmPortals.forEach(function(nmPortal) {
            // Find the nearest .add-to-cart-cont and .main-cont-atc for this nm-portal
            const addToCartCont = nmPortal.closest('.add-to-cart-cont');
            const mainContAtc = nmPortal.closest('.main-cont-atc');

            // Only proceed if it's still inside an .add-to-cart-cont
            if (addToCartCont && addToCartCont.contains(nmPortal)) {
                // Remove from .add-to-cart-cont
                addToCartCont.removeChild(nmPortal);

                // Append into its .main-cont-atc (below buttons)
                if (mainContAtc) {
                    mainContAtc.appendChild(nmPortal);
                }
            }
        });
    }

    // Initial move on page load
    moveNmPortal();

    // Observe for dynamic additions
    const observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length) {
                // If any new .nm-portal appears, try moving again
                if (document.querySelectorAll('.nm-portal').length > 0) {
                    moveNmPortal();
                }
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

var flkty;
var initialized = false;

function initFlickityOnMobile() {
  var isMobile = window.innerWidth < 768;
  var slider = document.querySelector('#slider-mobile');

  if (!slider) return;

  if (isMobile && !initialized) {
    flkty = new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      wrapAround: true,
      prevNextButtons: false,
      autoPlay: 5000
    });
    initialized = true;
  } else if (!isMobile && initialized) {
    flkty.destroy();
    initialized = false;
  }
}

window.addEventListener('load', initFlickityOnMobile);
window.addEventListener('resize', initFlickityOnMobile);

const footer = document.getElementById('Footer-menu_gNVzk4');

if (footer) {
  const phoneLinks = footer.querySelectorAll('a[href^="tel:"]');
  phoneLinks.forEach(link => {
    link.classList.add('phone-footer');
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("body.template-product .prime-countdown-header");
  if (header) {

    const match = header.textContent.match(/SALE ENDS IN/i);
    if (match) {
      header.textContent = match[0];
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const placeholder = "https://cdn.shopify.com/s/files/1/0867/8555/6644/files/Product_Detail_Placeholder.jpg?v=1749704028";
    const images = document.querySelectorAll(".template-product .recently-viewed-container img");
  
    images.forEach(function (img) {
      const src = img.getAttribute("src");
      if (!src || src.trim() === "" || src === "#" || src === "null") {
        img.setAttribute("src", placeholder);
      }
    });
  }, 3000);
});

function equalizePriceHeights() {
  const priceElements = document.querySelectorAll(".template-collection .collection-grid__wrapper .grid-product__price");

  priceElements.forEach(el => {
    el.style.height = "auto";
  });

  let maxHeight = 0;
  priceElements.forEach(el => {
    const height = el.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  priceElements.forEach(el => {
    el.style.height = maxHeight + "px";
  });
}

document.addEventListener("DOMContentLoaded", equalizePriceHeights);

window.addEventListener("resize", function () {
  clearTimeout(window.priceHeightTimeout);
  window.priceHeightTimeout = setTimeout(equalizePriceHeights, 150);
});
function moveSquarePlacements() {
  const productBlocks = document.querySelectorAll('.product-block');

  productBlocks.forEach(block => {
    const squarePlacement = block.querySelector('square-placement');
    const productPolicies = block.querySelector('.product__policies');

    if (squarePlacement && productPolicies && !squarePlacement.classList.contains('moved')) {
      productPolicies.insertAdjacentElement('afterend', squarePlacement);
      squarePlacement.classList.add('moved'); // Prevent double move
    }
  });
}

// Run once on initial load
document.addEventListener("DOMContentLoaded", function () {
  moveSquarePlacements();

  // Setup observer for dynamic content
  const observer = new MutationObserver(function (mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        moveSquarePlacements(); // Re-try moving newly added placements
        break;
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

